import React from 'react'
import { useTranslation } from 'next-i18next'
import { CustomTitle } from 'src/components'
import { UsersAdmin } from 'src/core/models'

const UserAdminGroupsColumn: React.FC<{ user: UsersAdmin }> = ({ user }) => {
  const { t } = useTranslation()
  const groupsData = user.groups_name.join(', ')
  const label = user.groups_name.length === 0 ? t('Validate.NoRol') : groupsData

  return <CustomTitle label={label} />
}

export default UserAdminGroupsColumn
